import { useDispatch } from "react-redux";
import type { AppDispatch } from "@/store/store";
import { actions as appReadyActions } from "@/store/appReadyReducer";
import { actions as cacheActions, type CacheItem, type CacheState } from "@/store/cacheReducer";
import { actions as pageLoadingActions, type LoadingMode } from "@/store/pageLoadingReducer";
import { actions as alertActions, type PushAlertPayload } from "@/store/alertReducer";
import {
  actions as cartActions,
  thunkActions as cartThunkActions,
  type Cart,
  type CartItem,
} from "@/store/cartReducer";

const useAppDispatch = () => {
  const dispatch = useDispatch<AppDispatch>();

  return {
    /* AppReady Actions */
    setAppReady: () => {
      dispatch(appReadyActions.setAppReady());
    },

    /* Cache  */
    setCache: (key: string, cacheItem: CacheItem) => {
      dispatch(cacheActions.setCache(key, cacheItem));
    },
    restoreCache: (cache: CacheState) => {
      dispatch(cacheActions.restoreCache(cache));
    },

    /* PageLoading Actions */
    setPageLoading: (show: boolean, mode?: LoadingMode) => {
      dispatch(pageLoadingActions.setPageLoading(show, mode));
    },

    /* Alert Actions */
    pushAlert: (payload: PushAlertPayload) => {
      dispatch(alertActions.pushAlert(payload));
    },

    removeAlert: (id: number) => {
      dispatch(alertActions.removeAlert(id));
    },

    clearAlerts: () => {
      dispatch(alertActions.clearAlerts());
    },

    /* Cart */
    setFullCart: (cart: Cart) => {
      dispatch(cartActions.setFullCart(cart));
    },

    addCartItem: (cartItem: CartItem) => {
      dispatch(cartThunkActions.addCartItem(cartItem));
    },

    clearCartItems: () => {
      dispatch(cartActions.clearCartItems());
    },

    removeCartError: (errorIndex: number) => {
      dispatch(cartActions.removeCartError(errorIndex));
    },
  };
};

export default useAppDispatch;
